/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.32/esri/copyright.txt for details.
*/
const o="esri-search",e={base:o,autocomplete:`${o}__autocomplete`,dropdown:`${o}__dropdown`,container:`${o}__container`,form:`${o}__form`};export{e as css};
